import { makeRequest } from 'utils/requestLogger';

export default (id) =>
  makeRequest('get', `/api/courses/${id}`).then((res) => res.data);



// WEBPACK FOOTER //
// ./src/app/services/courses/courseDetails.js